import { resolveMarketplacePath } from "@/domains/multi/clinicMemberPaths";
import { resolveSecretaryModuleActive } from "@/domains/shared/services/secretaryClinicalPaths";
import { useAuth } from "@/domains/shared/hooks/useAuth";
import { Roles } from "@/domains/shared/models/roles";
import { Navigate, Outlet } from "react-router";

export default function SecretaryModuleRouteGuard() {
    const { user } = useAuth();

    if (user?.role !== Roles.Therapist) {
        return <Outlet />;
    }

    if (!resolveSecretaryModuleActive(user)) {
        return <Navigate to={resolveMarketplacePath(user, "secretary")} replace />;
    }

    return <Outlet />;
}
